import { call, put, takeEvery } from 'redux-saga/effects';
import * as api from 'api/access/access';
import {
  CREATE_NEW_INTERNAL_USER,
  GET_ALL_ROLES,
  GET_ALL_INTERNAL_USERS,
  GET_ACCESS_LOGS,
  UPDATE_INTERNAL_USER,
  DELETE_INTERNAL_USER,
  RESET_INTERNAL_USER_PASSWORD,
  SEARCH_INTERNAL_USER,
  CLEAR_INTERNAL_USER_INPUT_SEARCH,
} from 'state/actionTypes';

import * as toastActions from 'state/toast/actions';
import {
  getAllRolesSuccess,
  closeAddUserModal,
  setCreatedUserState,
  getAllInternalUsersSuccess,
  getAccessLogsSuccess,
  closeEditInternalUserModalWindow,
  updatingInternalUser,
  deletingInternalUser,
  closeDeleteInternalUserModalWindow,
  getAllInternalUsers as getAllInternalUsersAction,
  getAccessLogs as getAccessLogsAction,
  resettingInternalUserPassword,
  closeResetInternalUserPasswordModal,
  searchingInternalUser,
  setInternalUserInputSearch,
} from './actions';

export function* getAllRoles({ payload }) {
  try {
    const { initialState } = payload;
    const {
      data: { data },
    } = yield call(api.performGetAllRoles);
    yield put(getAllRolesSuccess({ initialState, data }));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get all roles', error.message)
    );
  }
}

function* fetchAll() {
  const payloadInternalUsers = { page: 1, size: 10 };
  const payloadAccessLogs = {
    currState: {},
    requestMetadata: {
      group: 'access',
      item: '',
      page: 1,
      size: 20,
    },
  };
  yield put(getAllInternalUsersAction(payloadInternalUsers));
  yield put(getAccessLogsAction(payloadAccessLogs));
}

export function* createNewInternalUser({ payload }) {
  try {
    yield call(api.performCreateNewUser, payload);
    yield put(setCreatedUserState());
    yield put(closeAddUserModal());
    yield put(toastActions.successMessage('Successfully to create new user'));
    yield call(fetchAll);
  } catch (error) {
    if (error.response) {
      if (error.response.data)
        if (error.response.data.errors) {
          yield put(
            toastActions.errorMessage(
              'Failed to create new user',
              error.response.data.errors[0]
            )
          );
        } else if (error.response.data.data) {
          yield put(
            toastActions.errorMessage(
              'Failed to create new user',
              error.response.data.data.message
            )
          );
        }
    } else {
      yield put(
        toastActions.errorMessage('Failed to create new user', error.message)
      );
    }
  } finally {
    yield put(setCreatedUserState());
  }
}

export function* getAllInternalUsers({ payload }) {
  try {
    const {
      data: { data, paging },
    } = yield call(api.performGetAllInternalUsers, payload);
    yield put(getAllInternalUsersSuccess({ data, paging }));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get internal users', error.message)
    );
  }
}

export function* getAccessLogs({ payload }) {
  try {
    const { currState, requestMetadata } = payload;
    const {
      data: { data, paging },
    } = yield call(api.performGetAccessLogs, requestMetadata);
    yield put(getAccessLogsSuccess({ currState, newState: { data, paging } }));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get access logs', error.message)
    );
  }
}

export function* updateInternalUser({ payload }) {
  try {
    yield call(api.performUpdateUser, payload);
    yield put(updatingInternalUser(false));
    yield put(closeEditInternalUserModalWindow());
    yield put(
      toastActions.successMessage('Successfully to update the internal user')
    );
    yield call(fetchAll);
  } catch (error) {
    if (error.response) {
      if (error.response.data)
        if (error.response.data.errors) {
          yield put(
            toastActions.errorMessage(
              'Failed to update the internal user',
              error.response.data.errors[0]
            )
          );
        } else if (error.response.data.data) {
          yield put(
            toastActions.errorMessage(
              'Failed to update the internal user',
              error.response.data.data.message
            )
          );
        }
    } else {
      yield put(
        toastActions.errorMessage(
          'Failed to update the internal user',
          error.message
        )
      );
    }
  } finally {
    yield put(updatingInternalUser(false));
  }
}

export function* deleteInternalUser({ payload }) {
  try {
    yield call(api.performDeleteUser, payload);
    yield put(deletingInternalUser(false));
    yield put(closeDeleteInternalUserModalWindow());
    yield put(toastActions.successMessage('Successfully to delete the user'));
    yield call(fetchAll);
  } catch (error) {
    if (error.response) {
      if (error.response.data)
        if (error.response.data.errors) {
          yield put(
            toastActions.errorMessage(
              'Failed to delete the user',
              error.response.data.errors[0]
            )
          );
        } else if (error.response.data.data) {
          yield put(
            toastActions.errorMessage(
              'Failed to delete the user',
              error.response.data.data.message
            )
          );
        }
    } else {
      yield put(
        toastActions.errorMessage('Failed to delete the user', error.message)
      );
    }
  } finally {
    yield put(deletingInternalUser(false));
  }
}

export function* resetInternalUserPassword({ payload }) {
  try {
    yield put(resettingInternalUserPassword(true));
    yield call(api.performResetUserPassword, payload);
    yield put(resettingInternalUserPassword(false));
    yield put(closeResetInternalUserPasswordModal());
    yield put(closeEditInternalUserModalWindow());
    yield put(
      toastActions.successMessage('User password has been reset successfully')
    );
    yield call(fetchAll);
  } catch (error) {
    if (error.response) {
      if (error.response.data) {
        if (error.response.data.errors) {
          yield put(
            toastActions.errorMessage(
              'Failed to reset user password',
              error.response.data.errors[0]
            )
          );
        } else if (error.response.data.data) {
          yield put(
            toastActions.errorMessage(
              'Failed to reset user password',
              error.response.data.data.message
            )
          );
        } else {
          yield put(
            toastActions.errorMessage(
              'Failed to reset user password',
              error.message
            )
          );
        }
      } else {
        yield put(
          toastActions.errorMessage(
            'Failed to reset user password',
            error.message
          )
        );
      }
    } else {
      yield put(
        toastActions.errorMessage(
          'Failed to reset user password',
          error.message
        )
      );
    }
  } finally {
    yield put(resettingInternalUserPassword(false));
  }
}

export function* searchInternalUser({ payload }) {
  yield put(searchingInternalUser(true));
  yield call(getAllInternalUsers, getAllInternalUsersAction(payload));
  yield put(searchingInternalUser(false));
}

export function* clearInternalUserInputSearch({ payload }) {
  yield call(searchInternalUser, setInternalUserInputSearch(payload));
  yield put(setInternalUserInputSearch(''));
}

export default function* saga() {
  yield takeEvery(GET_ALL_ROLES, getAllRoles);
  yield takeEvery(CREATE_NEW_INTERNAL_USER, createNewInternalUser);
  yield takeEvery(GET_ALL_INTERNAL_USERS, getAllInternalUsers);
  yield takeEvery(GET_ACCESS_LOGS, getAccessLogs);
  yield takeEvery(UPDATE_INTERNAL_USER, updateInternalUser);
  yield takeEvery(DELETE_INTERNAL_USER, deleteInternalUser);
  yield takeEvery(RESET_INTERNAL_USER_PASSWORD, resetInternalUserPassword);
  yield takeEvery(SEARCH_INTERNAL_USER, searchInternalUser);
  yield takeEvery(
    CLEAR_INTERNAL_USER_INPUT_SEARCH,
    clearInternalUserInputSearch
  );
}
